import * as React from "react";

import { ReactSelectOptions } from "../../../../../types";
import * as sc from "./ColorFilter.sc";
import ColorItem from "./coloritem/ColorItem";
interface IColorFilterProps {
    selectedColors?: string[];
    options: ReactSelectOptions<string>[];
    onChange?: (value: string[] | null) => void;
}

const ColorFilter: React.FunctionComponent<IColorFilterProps> = ({ selectedColors, options, onChange }) => {
    const onColorItemClicked = (color: ReactSelectOptions<string>, selected: boolean) => {
        if (onChange) {
            const selectedArray: string[] = [];
            if (selectedColors) {
                selectedArray.push(...selectedColors);
            }

            if (selected) {
                selectedArray.push(color.value);
                onChange(selectedArray);
            } else {
                onChange(
                    selectedArray.filter((item) => {
                        return item !== color.value;
                    }),
                );
            }
        }
    };
    return (
        <sc.Root>
            {options.map((color, index) => {
                const isSelected = selectedColors?.includes(color.value) ?? false;
                return <ColorItem key={index} color={color.value} isSelected={isSelected} onClick={onColorItemClicked.bind(null, color)} />;
            })}
        </sc.Root>
    );
};
export default ColorFilter;
